import type { BrowserOptions } from '@sentry/react'

type SentryEnvOptions = Pick<
  BrowserOptions,
  | 'enabled'
  | 'environment'
  | 'tracesSampleRate'
  | 'replaysSessionSampleRate'
  | 'replaysOnErrorSampleRate'
  | 'tracePropagationTargets'
  | 'ignoreSpans'
>

// Timing spans for every JS/CSS file, paint and performance marks: about half of the span quota,
// and web vitals do not depend on them.
const IGNORED_SPANS = [{ op: /^resource\./ }, { op: /^paint$/ }, { op: /^mark$/ }, { op: /^measure$/ }]

const PRODUCTION_RATES = {
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.2,
}

const STAGING_RATES = {
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
}

export const buildSentryOptions = (env: string): SentryEnvOptions => {
  const isProduction = env === 'production'
  const isStaging = env === 'staging'

  return {
    enabled: isProduction || isStaging,
    environment: env,
    ...(isProduction ? PRODUCTION_RATES : STAGING_RATES),
    // The backend sends no traces, so no request carries trace headers.
    tracePropagationTargets: [],
    ignoreSpans: IGNORED_SPANS,
  }
}
